import { handleActions } from 'redux-actions';
import {
  historyInitialLoadStart,
  historyInitialLoadCompleted,
  historyLoadStart,
  historyLoadCompleted,
  historyFailed,
  removeAppointmentFromHistory
} from '../actions/history';

import { resetBooking } from '../actions/booking';

const initialState = {
  historyInitialLoading: false,
  historyInitialLoaded: false,
  historyLoading: false,
  historyLoaded: false,
  reservations: [],
  numberOfResults: 0
};

const ticketReducer = handleActions({
  [historyInitialLoadStart]: state => ({
    ...state,
    historyInitialLoading: true,
    historyInitialLoaded: false
  }),
  [historyInitialLoadCompleted]: (state, action) => ({
    ...state,
    historyInitialLoading: false,
    historyInitialLoaded: true,
    reservations: state.reservations.concat(action.payload),
    numberOfResults: action.payload.length
  }),
  [historyLoadStart]: state => ({
    ...state,
    historyLoading: true,
    historyLoaded: false
  }),
  [historyLoadCompleted]: (state, action) => ({
    ...state,
    historyLoading: false,
    historyLoaded: true,
    reservations: state.reservations.concat(action.payload),
    numberOfResults: action.payload.length
  }),
  [historyFailed]: state => ({
    ...state,
    historyLoading: false,
    historyLoaded: false
  }),
  [removeAppointmentFromHistory]: (state, action) => ({
    ...state,
    reservations: state.reservations.filter(r => r.reservation !== action.payload)
  }),
  [resetBooking]: () => ({
    ...initialState
  })
}, initialState);

export default ticketReducer;



// WEBPACK FOOTER //
// ./src/reducers/history.js